import React, {Component} from 'react';
import './PortalNavItem.css';
import PropTypes from 'prop-types';
import {Link} from "react-router-dom";

export default class PortalNavItem extends Component {
    render() {
        let classNames = ["PortalNavItem"];

        if (this.props.active) {
            classNames.push("PortalNavItem--active");
        }

        let canExpand = !!this.props.children;
        let isExpanded = canExpand && this.props.active;

        if (isExpanded) {
            classNames.push("PortalNavItem--expanded")
        }

        return (
            <div>
                <Link className={classNames.join(' ')} title={this.props.label} to={this.props.href}>
                    {this.props.icon && <i className={"PortalNavItem__icon mdi mdi-" + this.props.icon}/>}
                    <span className={"PortalNavItem__label"}>{this.props.label}</span>
                    <span className={"PortalNavItem__fill"}/>
                    {canExpand &&
                        <i className={"mdi mdi-chevron-down"}/>
                    }
                </Link>
                {isExpanded &&
                <div className={"PortalNavItem__expand"}>
                    {this.props.children}
                </div>
                }
            </div>
        );
    }
}

PortalNavItem.propTypes = {
    label: PropTypes.string.isRequired,
    href: PropTypes.string.isRequired,
    icon: PropTypes.string,
    active: PropTypes.bool
};



// WEBPACK FOOTER //
// ./src/Portal/Parts/PortalNavItem.js